import { Injectable } from '@angular/core';
import { GlobalService } from '../service/global.service';

@Injectable({
  providedIn: 'root'
})
export class ValidateService {

  constructor(private globalService: GlobalService) {
    this.globalService.CheckPagingAccessRights();
  }

  isValidLeadFormat(LeadCode: string): boolean {    
  if (!LeadCode || LeadCode.length !== 11) return true;
    const prefix = LeadCode.substring(0, 4);   // "LEAD"
    const year = LeadCode.substring(4, 6);     // "25"
    const running = LeadCode.substring(6);     // "00001"

    const isPrefixValid = prefix === 'LEAD';
    const isYearValid = /^\d{2}$/.test(year);         // year ต้องเป็นตัวเลข 2 หลัก
    const isRunningValid = /^\d{5}$/.test(running);   // running ต้องเป็นตัวเลข 5 หลัก

    const isFormatValid = isPrefixValid && isYearValid && isRunningValid;

    return !isFormatValid;
  }
}
